import './App.scss';
import 'animate.css';
import { useEffect } from "react";
import { BrowserRouter} from "react-router-dom";
import Header from "./components/core/Header/Header";
import MyRoutes  from "./components/routes/MyRoutes";
import { useSelector,useDispatch } from "react-redux";
import OpenRoutes from "./components/routes/OpenRoutes";
import { setMe, setToken } from "./store/actions/authActions";
import SideBar from "./components/core/SideBar/SideBar";
import usersService from "./Axios/services/users.service";
import SessionsService from "./Axios/services/sessions.service";
import MobileNav from "./components/core/MobileNav/MobileNav";
import { ContentSideArea } from "./components/core/ContentSideArea/ContentSideArea";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common_en from "./Lang/dictionary/common.json";
import english_lang from "./Lang/dictionary/English.json";
import hebrew_lang from "./Lang/dictionary/Hebrew.json";
import arabic_lang from "./Lang/dictionary/Arabic.json";
import Toast from "./components/core/Toast/Toast";
import { showToast } from "./store/actions/toastActions";
import { setAxiosInterceptors } from './Axios/axios';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: common_en,
      English: english_lang,
      Hebrew: hebrew_lang,
      Arabic: arabic_lang,
    },
  },
  lng: "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

const App = () => {
 
  const { me } = useSelector((state: any) => state.auth);
  const queryParams = new URLSearchParams(window.location.search);
  const tokenFromQuery =   queryParams.get('token');
    
  // Use token from URL or fallback to token in localStorage
  const tokenToUse = tokenFromQuery || localStorage.getItem('token');

  const { open, message, severity } = useSelector((state: any) => state.toast);
  const dispatch = useDispatch();

  useEffect(() => {
    setAxiosInterceptors(tokenToUse);
 
    if (!me) {
      getMe();
    }
   
  }, [tokenToUse, me]);

  
  const getMe = async () => {
    let meData = me;
    if (meData == null) {
      try {
        meData = await usersService.me();
        dispatch(setMe(meData));
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        dispatch(setToken(''));
        dispatch(setMe(null));
        localStorage.removeItem('token');
        return;
      }
    }

    getUserExtraData(meData);
  };

 //TO DO : ADD DIRECTLY ON COMMUNITY COMPONENT
  const getUserFriends = async (me) => {
    const connections = await  usersService.getFriendsByUserId(me?._id);
    me.connections = connections;
    dispatch(setMe(me));
  }
 
   //TO DO: ADD DIRECTLY ON CLASSES COMPONENT
  const getUserSessions = async (me) => {
    const userClasses = await SessionsService.getSessionsForLoggedInUser(me._id);
    me.classes = userClasses.length > 0 ? userClasses : null ;
    dispatch(setMe(me));
  }

  const getUserExtraData = async (me) => {
    if (me !== null) {
        const promiseAllCall = [getUserFriends(me)];
  
        if (me?.classes && Array.isArray(me.classes) && me.classes.length > 0) {
          promiseAllCall.push(getUserSessions(me));
        }
        try {
         
          Promise.all(promiseAllCall);
           
        } catch (error) {
            console.error('Error fetching user extra data:', error);
        }
    }
};

  const handleClose = () => {
    dispatch(showToast({ open: false, message: "" }));
  };

  return (tokenToUse ?
      <BrowserRouter>
        <div className="App">
          <Header />
          <div className="app-body">
            <ContentSideArea />
            <div className="container px-0 pb-md-0 pb-5">
              <div className="row">
                <div className="floatingSideArea d-none d-lg-flex col-lg-3 p-0">
                  <SideBar />
                </div>
                <div className="col-lg-9 col-12 p-0">
                  <MyRoutes />
                </div>
              </div>
            </div>
          </div>
          <MobileNav />
          <Toast open={open} message={message} onClose={handleClose} severity={severity} />
        </div>
      </BrowserRouter>:
      <BrowserRouter>
        <OpenRoutes />
      </BrowserRouter>
  );
};

export default App;
